var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnowledgeBase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78216 3.70312H16.2169C19.165 3.70312 21 5.78431 21 8.7295V16.6767C21 19.6219 19.165 21.7031 16.2159 21.7031H7.78216C4.83405 21.7031 3 19.6219 3 16.6767V8.7295C3 5.78431 4.84281 3.70312 7.78216 3.70312Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70022 15.7859C9.8493 15.8686 10.8495 16.3385 11.4391 16.68C11.7875 16.8824 12.2136 16.8824 12.5629 16.68C13.1525 16.3385 14.1518 15.8686 15.3009 15.7859C15.8885 15.7431 16.3527 15.2731 16.3527 14.6835V9.68243C16.3527 9.01983 15.7728 8.51097 15.1131 8.58297C14.0438 8.69972 13.1195 9.13756 12.5629 9.46059C12.2136 9.66199 11.7875 9.66199 11.4391 9.46059C10.8816 9.13756 9.95828 8.69972 8.88898 8.58297C8.2293 8.51097 7.64844 9.01983 7.64844 9.68243V14.6835C7.64844 15.2731 8.11255 15.7431 8.70022 15.7859Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.74414V16.805",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBase);
export default __webpack_public_path__ + "static/media/knowledge-base.cf7503ab.svg";
export { ForwardRef as ReactComponent };